import * as Yup from 'yup';

export const agentFormYopValidation = () => {
  return Yup.object().shape({
    name: Yup.string().required('required'),
    instructions: Yup.string().required('required'),
  });
};
